'use strict';

module.exports = {
  GALLERY: 'gallery',
  POSTER: 'poster',
  COVER: 'cover',
  TEXT: 'text',
  MEDIA: 'media',
  INFO: 'info',
  // Experimental:
  BUY_IN_ITUNES: 'buy_in_itunes'
};


/** WEBPACK FOOTER **
 ** ./constants/SectionTypes.js
 **/